// eslint-disable-next-line import/no-cycle
import {
  SIGN_IN_WITH_EMAIL,
  SIGN_IN_WITH_EMAIL_SUCCESS,
  SIGN_IN_WITH_EMAIL_ERROR,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from '../actions';

export const signInWithEmail = (params, callback) => ({
  type: SIGN_IN_WITH_EMAIL,
  payload: { params },
  callback,
})
export const signInWithEmailSuccessed = (data) => ({
  type: SIGN_IN_WITH_EMAIL_SUCCESS,
  payload: data,
});
export const signInWithEmailFailed = (error) => ({
  type: SIGN_IN_WITH_EMAIL_ERROR,
  payload: error
});

export const forgotPassword = (params, callback) => ({
  type: FORGOT_PASSWORD,
  payload: { params },
  callback
});
export const forgotPasswordSuccessed = (data) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: data,
});
export const forgotPasswordFailed = (error) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: error
});

export const resetPassword = (params, callback) => ({
  type: RESET_PASSWORD,
  payload: { params },
  callback
});
export const resetPasswordSuccessed = (data) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: data,
});
export const resetPasswordFailed = (error) => ({
  type: RESET_PASSWORD_ERROR,
  payload: error
});